export default (t) => {
    return [
        {
            header: t('Process'),
            accessor: 'name',
        },
        {
            header: t('Time'),
            accessor: 'time'
        },
        {
            header: t('Process ID'),
            accessor: 'pid'
        },
        {
            header: t('Image'),
            accessor: 'image'
        },
        {
            header: t('CMD'),
            accessor: 'cmd'
        },
        {
            header: t('Status'),
            accessor: 'status',
            parser: (value) => '0x' + value.toString(16).toUpperCase().padStart(8, '0')
        },
        {
            header: t('Kind'),
            accessor: 'kind'
        },
        {
            header: t('Origin'),
            accessor: 'orig',
            parser: (value) => value ? t('true') : t('false')
        },
        {
            header: t('Parent Process'),
            accessor: 'parent_proc'
        }
    ];
};
